import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  taHardwaresGroup: [],
}

export const mutations = {
  SET_TA_HARDWARES_GROUP(state, taHardwaresGroup) {
    state.taHardwaresGroup = taHardwaresGroup
  },
  ADD_TA_HARDWARE_GROUP(state, taHardwareGroup) {
    state.taHardwaresGroup.push(taHardwareGroup)
  },
  EDIT_TA_HARDWARE_GROUP(state, taHardwareGroup) {
    const index = state.taHardwaresGroup.findIndex(
      (e) => e.hardware_group_uuid === taHardwareGroup.hardware_group_uuid
    )
    if (index !== -1) {
      state.taHardwaresGroup.splice(index, 1, taHardwareGroup)
    }
  },
  DELETE_TA_HARDWARE_GROUP(state, hardware_group_uuid) {
    const index = state.taHardwaresGroup.findIndex(
      (e) => e.hardware_group_uuid === hardware_group_uuid
    )
    if (index !== -1) state.taHardwaresGroup.splice(index, 1)
  },
}

export const actions = {
  fetchTaHardwaresGroup({ commit }, payload) {
    return ApiService.fetchTaHardwaresGroup(payload)
      .then((res) => {
        const taHardwaresGroup = res.data.data
        commit('SET_TA_HARDWARES_GROUP', taHardwaresGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTaHardwareGroupById({ commit }, payload) {
    return ApiService.fetchTaHardwareGroupById(payload)
      .then((res) => {
        const taHardwareGroup = res.data
        return taHardwareGroup
      })
      .catch((error) => {
        throw error
      })
  },
  addTaHardwareGroup({ commit }, payload) {
    return ApiService.addTaHardwareGroup(payload)
      .then((res) => {
        const taHardwareGroup = res.data
        commit('ADD_TA_HARDWARE_GROUP', taHardwareGroup)
        return taHardwareGroup
      })
      .catch((error) => {
        throw error
      })
  },
  editTaHardwareGroup({ commit }, payload) {
    return ApiService.editTaHardwareGroup(payload)
      .then((res) => {
        const taHardwareGroup = res.data
        commit('EDIT_TA_HARDWARE_GROUP', taHardwareGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteTaHardwareGroup({ commit }, payload) {
    return ApiService.deleteTaHardwareGroup(payload)
      .then(() => {
        commit('DELETE_TA_HARDWARE_GROUP', payload.hardware_group_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTaHardwaresGroupMember({ commit }, payload) {
    return ApiService.fetchTaHardwaresGroupMember(payload)
      .then((res) => {
        const taHardwareGroupMember = res.data
        return taHardwareGroupMember
      })
      .catch((error) => {
        throw error
      })
  },
  addTaHardwareGroupMember({ commit }, payload) {
    return ApiService.addTaHardwareGroupMember(payload).catch((error) => {
      throw error
    })
  },
  deleteTaHardwareGroupMember({ commit }, payload) {
    return ApiService.deleteTaHardwareGroupMember(payload).catch((error) => {
      throw error
    })
  },
}
